export default {"src":"/_next/static/media/MovementDisorders.c7b4658e.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};